import { StringUtils } from "../../../../utils/stringUtils";
import { ReportProps, ValidationError, Validator } from "../../../../types/types";

export class ReportBasicDetailsValidator implements Validator<ReportProps> {
    validate(props: ReportProps): ValidationError[] {
        const errors: ValidationError[] = [];
        const info = props.reportInfo
        const viewMode= props.reportInfo.viewEditStatus==='VIEW'?true:false
        if (StringUtils.isEmpty(info.name) && !viewMode)
            errors.push(new ValidationError("nameError", "Please provide a meaningful Report name!"))
        else if (info.name.length < 3  && !viewMode)
            errors.push(new ValidationError("nameError", "Keep it meaningful ! This shouldn't less than 3 characters."))

        if (StringUtils.isEmpty(info.description) && !viewMode)
            errors.push(new ValidationError("descriptionError", "Please elaborate about your Report!"))
        else if (info.description.length < 10  && !viewMode)
            errors.push(new ValidationError("descriptionError", "Oops too short description!"))

        if (isNaN(info.fetchLimit)  && !viewMode)
            errors.push(new ValidationError("fetchLimitError", "Please provide valid number!"))
        else if (info.fetchLimit <= 0  && !viewMode)
            errors.push(new ValidationError("fetchLimitError", "Please provide valid number!"))

        if (StringUtils.isEmpty(info.owner) && !viewMode)
            errors.push(new ValidationError("ownerError", "Please select Report Owner name!"))

        return errors;
    }
}